import VectorSource from "ol/source/Vector";
import mapConfig from "../../map.config.json";
import {TopoJSON} from "ol/format";
import VectorLayer from "ol/layer/Vector";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import Text from "ol/style/Text";
import Fill from "ol/style/Fill";

/**
 * Definisce il sorgente per il layer con i contorni delle province
 * @type {*|VectorSource}
 */
const provinceLayerSource = new VectorSource({
    url: mapConfig.basePath + 'province.topojson.json',
    format: new TopoJSON()
});
/**
 * Definisce il layer con i contorni delle province
 * @type {*|VectorLayer}
 */
export const provinceLayer = new VectorLayer({
    source: provinceLayerSource,
    name: 'province',
    style: getProvinciaStyle
});

export function getProvinciaStyle(feature, resolution) {
    return new Style({
        stroke: new Stroke({
            color: '#FFFFFF',
            width: 4
        }),
        text: new Text({
            text: feature.values_.hover ? '' : feature.values_.provincia,
            font: '24px "Titillium Web"',
            fill: new Fill({color: '#006699'}),
            stroke: new Stroke({color: '#FFFFFF', width: 2}),
            offsetX: 0,
            offsetY: 0
        })
    });
}
